
// import Home from './views/Home.vue'
import Vue from 'vue'
import VueFullPage from 'vue-fullpage.js'
import Router from 'vue-router'
// import Home from '@/components/Home'
import HelloWorld from './views/HelloWorld.vue'
import addActivities from './views/addActivities.vue'
import Activities from './views/Activities.vue'
import ActivitiesOld from './views/ActivitiesOld.vue'
import Introduction from './views/Introduction.vue'
import Links from './views/Links.vue'
import Postit from './views/Postit.vue'
import Resources from './views/Resources.vue'
import Initiative from './views/Initiative.vue'
import InitiativeS from './views/InitiativeS.vue'
import InitiativeL from './views/InitiativeL.vue'
import InitiativeT from './views/InitiativeT.vue'
import InitiativeR from './views/InitiativeR.vue'
import Login from './views/Login.vue'
import Signup from './views/Signup.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(VueFullPage)
Vue.use(Router)
Vue.use(BootstrapVue)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/intro',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/home',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/activities',
      name: 'Activities',
      component: Activities
    },
    {
      path: '/activitiesold',
      name: 'ActivitiesOld',
      component: ActivitiesOld
    },
    {
      path: '/addactivities',
      name: 'addActivities',
      component: addActivities
    },
    {
      path: '/addactivities',
      name: 'addActivities',
      component: addActivities
    },
    {
      path: '/intro',
      // redirect:'./',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/links',
      name: 'Links',
      component: Links
    },
    {
      path: '/resources',
      name: 'Resources',
      component: Resources
    },
    {
      path: '/postit',
      name: 'Postit',
      component: Postit
    },
    {
      path: '/initiative-brief',
      name: 'Initiative',
      component: Initiative
    },
    {
      path: '/initiative-support',
      name: 'InitiativeS',
      component: InitiativeS
    },
    {
      path: '/initiative-librarian',
      name: 'InitiativeL',
      component: InitiativeL
    },
    {
      path: '/initiative-teacher',
      name: 'InitiativeT',
      component: InitiativeT
    },
    {
      path: '/initiative-research',
      name: 'InitiativeR',
      component: InitiativeR
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   let currentUser = firebase.auth().currentUser;
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth && !currentUser) next('login')
//   else if (!requiresAuth && currentUser) next('introduction')
//   else next()
// })
